import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'success',
  autoHideDuration: 3000,
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity;
      state.autoHideDuration = action.payload.duration || 3000;
    },
    hideSnackbar: (state) => {
      state.open = false;
    },
  },
});

export const { 
    showSnackbar, 
    hideSnackbar,
} = snackbarSlice.actions;
export default snackbarSlice.reducer;